/* CR7 URSU9 Theme — runtime behavior
   - Toggles .is-mobile on <body> when viewport <= min_content_width setting
   - Hamburger menu open/close
   - Lightweight cart count updater
*/

(function () {
  var root = document.documentElement;
  var body = document.body;

  // Read breakpoint from CSS var (set by theme.liquid from settings)
  function getMobileBreakpoint() {
    var cs = getComputedStyle(root);
    var raw = cs.getPropertyValue('--min-content-width').trim();
    var n = parseInt(raw, 10);
    return isNaN(n) ? 720 : n;
  }

  function evaluateLayout() {
    var bp = getMobileBreakpoint();
    var isMobile = window.innerWidth <= bp;
    body.classList.toggle('is-mobile', isMobile);
  }

  var rafId = null;
  window.addEventListener('resize', function () {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(evaluateLayout);
  });
  evaluateLayout();

  /* ---------- Hamburger / mobile drawer ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-toggle-mobile-nav]');
    if (toggle) {
      e.preventDefault();
      var drawer = document.getElementById('MobileNav');
      if (drawer) {
        var open = drawer.getAttribute('aria-hidden') !== 'false';
        drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
        body.style.overflow = open ? 'hidden' : '';
      }
      return;
    }
    var close = e.target.closest('[data-close-mobile-nav]');
    if (close || (e.target.classList && e.target.classList.contains('mobile-nav'))) {
      var drawer = document.getElementById('MobileNav');
      if (drawer) {
        drawer.setAttribute('aria-hidden', 'true');
        body.style.overflow = '';
      }
    }
  });

  /* ---------- YouTube playlist helper ---------- */
  // For playlists we support: whole playlist, subset by start/end index, or single index.
  // The section renders the iframe with the resolved src, so nothing to do here at runtime.

  /* ---------- Cart count updater ---------- */
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return;
        var el = document.querySelector('[data-cart-count]');
        if (el) el.textContent = c.item_count || 0;
      })
      .catch(function(){});
  }

  // Intercept Add to cart forms (progressive — falls back to normal POST if fetch fails)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action="/cart/add"], form[action^="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (res.ok) {
          refreshCart();
          var btn = form.querySelector('[type="submit"]');
          if (btn) {
            var old = btn.textContent;
            btn.textContent = 'Added';
            setTimeout(function () { btn.textContent = old; }, 1200);
          }
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () { window.location.href = '/cart'; });
  });

  refreshCart();
})();
